import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import {
  cedentePortalAccessGuard,
  PORTAL_ROUTE_DATA_KEY,
  PORTAL_SLUG_PARAM,
  sacadoPortalAccessGuard,
  sacadoPortalMatchGuard,
  sacadoPortalResolver,
} from './core/portal/portal.guards';
import { ACCESS_DENIED_PATH } from './core/portal/portal-slug';
import { loadPortalFeature } from './app-feature-loader';

const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    children: [
      {
        path: ACCESS_DENIED_PATH,
        loadComponent: () =>
          import('./core/pages/access-denied/access-denied.component').then(
            (m) => m.AccessDeniedComponent,
          ),
      },
      {
        path: `:${PORTAL_SLUG_PARAM}`,
        canMatch: [sacadoPortalMatchGuard],
        canActivate: [sacadoPortalAccessGuard],
        resolve: { [PORTAL_ROUTE_DATA_KEY]: sacadoPortalResolver },
        loadChildren: () =>
          import('./features/buyer-anticipation-portal/buyer-anticipation-portal.routes').then(
            (m) => m.BUYER_ANTICIPATION_PORTAL_ROUTES,
          ),
      },
      {
        path: '',
        canActivate: [cedentePortalAccessGuard],
        loadChildren: loadPortalFeature,
      },
    ],
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
